import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { contractAlertsApi } from '../../../api/contracts';
import { notifications } from '@mantine/notifications';

export const useContractAlerts = (contractId?: string) => {
  return useQuery({
    queryKey: ['contractAlerts', contractId],
    queryFn: async () => {
      // If contractId is provided, get alerts from contract
      if (contractId) {
        const { contractsApi } = await import('../../../api/contracts');
        const contract = await contractsApi.get(contractId);
        return contract.alerts || [];
      }
      // Otherwise, get all unread alerts from all contracts
      const { contractsApi } = await import('../../../api/contracts');
      const contracts = await contractsApi.list();
      const allAlerts = contracts.flatMap((c) => c.alerts || []).filter((a) => !a.isRead);
      return allAlerts;
    },
    enabled: true,
  });
};

export const useAcknowledgeAlert = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ contractId, alertId }: { contractId: string; alertId: string }) =>
      contractAlertsApi.acknowledge(contractId, alertId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['contractAlerts'] });
      queryClient.invalidateQueries({ queryKey: ['contract', variables.contractId] });
      queryClient.invalidateQueries({ queryKey: ['contracts'] });
      notifications.show({
        title: 'Success',
        message: 'Alert acknowledged',
        color: 'green',
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: 'Error',
        message: error.response?.data?.error || 'Failed to acknowledge alert',
        color: 'red',
      });
    },
  });
};

